export default __webpack_public_path__ + "static/media/AnjuSoni.d22f95ea.jpeg";